<template>
	<div class="fill-height pt-3">
		<v-card style="width: 100%">
			<v-card-text>
				<v-row>
					<v-col lg="6" md="5" sm="12" cols="12" align-self="center" class="py-1">
						<v-row dense>
							<v-col cols="12" sm="6">
								<v-autocomplete
									v-model="userIds"
									:items="usersWithoutPag"
									item-value="id"
									:item-text="(item) => `${item.employee.arabicFirstName}` + ' ' + `${item.employee?.arabicLastName}`"
									:disabled="loading"
									:return-object="false"
									multiple
									label="Employee"
									dense
									outlined
									filled
									hide-details
									class="rounded-lg"
									clearable
								>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" sm="6">
								<v-autocomplete
									v-model="categoryId"
									:items="categories"
									item-value="id"
									item-text="name"
									@change="CategoryChange"
									:disabled="loading"
									:return-object="false"
									label="Categories"
									dense
									outlined
									filled
									hide-details
									class="rounded-lg"
									clearable
								>
								</v-autocomplete>
							</v-col>
							<v-col cols="12" class="pt-0 d-flex">	
								<v-select
									v-model="projectIds"
									:items="categoryId ? projectsBrief.filter(c => c.categoryId === categoryId) : projectsBrief"
									item-text="name"
									item-value="id"
									label="Projects"
									multiple
									outlined
									clearable
									chips
									filled
									:dense="!projectIds.length"
									class="rounded-lg"
									hide-details
									:disabled="loading"
									deletable-chips
									:loading="projectLoading"
								>
									<template v-slot:prepend-item v-if="categoryId">
										<v-list-item
											ripple
											@mousedown.prevent
											@click="toggle"
										>
											<v-list-item-action>
												<v-icon :color="projectIds.length > 0 ? 'indigo darken-4' : ''">
												{{ icon }}
												</v-icon>
											</v-list-item-action>
											<v-list-item-content>
												<v-list-item-title>
												Select All
												</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
										<v-divider class="mt-2"></v-divider>
									</template>

									<template v-if="hide === true" v-slot:selection="{ item, index }">
										<span v-if="index === 0" class="me-1">{{ item.name }}</span>
										<span
											v-if="index === 1"
											class="black--text text-caption"
										>
											(+{{ projectIds.length - 1 }})
										</span>
									</template>
								</v-select>
								
								<v-btn v-if="projectIds.length" :disabled="loading" @click="hide = !hide" icon>
									<v-icon> mdi-plus-minus </v-icon>
								</v-btn>
							</v-col>
							<v-spacer />
						</v-row>
					
					</v-col>

					<v-col lg="5" md="4" sm="12" cols="12" align-self="center" class="py-1">
						<v-row>
							<v-col cols='12' sm="6" md="12" class="" align-self="start">
								<v-btn-toggle
									v-model="speacifice"
									mandatory
									dense
									class="d-flex justify-center"
									color="primary"
									style="width: 100%"
									:disabled="loading"
								>
									<v-btn 
										:disabled="loading" 
										value="yearly" 
										class="text-none" 
										style="width: 33%"
									> 
										Yearly 
									</v-btn>
									<v-btn
										:disabled="loading"
										value="monthly"
										class="text-none"
										style="width: 33%"
									>
										Monthly
									</v-btn>
									<v-btn
										:disabled="loading"
										value="period"
										class="text-none"
										style="width: 33%"
									>
										Period 
									</v-btn>
								</v-btn-toggle>
							</v-col>

							<v-col
								v-if="speacifice !== 'period'"
								sm="6"
								:md="speacifice === 'monthly' ? 6 : 12"
								align-self="start"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
								class="d-flex align-center"
							>
								<v-btn
									icon
									small
									@click="addYear()"
									:disabled="!year || loading"
								>
									<v-icon>
										mdi-menu-left
									</v-icon>									
								</v-btn>

								<v-autocomplete
									v-model="year"
									:items="years"
									item-text="name"
									item-value="name"
									hide-details='auto'
									label="Year"
									dense
									outlined
									filled
									class="rounded-lg"
									:disabled="loading"
								/>
								<v-btn 
									icon 
									small 
									@click="subYear()" 
									:disabled="!year ||  years.indexOf(year) === 0 || loading"
								>
									<v-icon>
										mdi-menu-right
									</v-icon>									
								</v-btn>
							</v-col>

							<v-col
								v-if="speacifice === 'monthly'"
								md="6"
								sm="12"
								align-self="start"
								:class="{
									'pl-0': $vuetify.breakpoint.mdAndUp,
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
								class="d-flex align-center"
							>
								<v-btn
									icon
									small
									@click="subMonth()"
									:disabled="!month || months.indexOf(year) === 0 || loading"
								>
									<v-icon>
										mdi-menu-left
									</v-icon>									
								</v-btn>
								<v-autocomplete
									v-model="month"
									:items='months'
									item-text="name"
									item-value="value"
									label="Month"
									class="rounded-lg"
									hide-details='auto'
									dense
									outlined
									filled
									:disabled="!year"
								></v-autocomplete>
								<v-btn icon small @click="addMonth()" :disabled="!month || loading">
									<v-icon>
										mdi-menu-right
									</v-icon>									
								</v-btn>
							</v-col>

							<v-col 
								v-if="speacifice === 'period'" 
								md="6"
								sm="12"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
								class="px-0"
							>
								<bee-date-input
									v-model="fromDate"
									append-icon="mdi-menu-right"
									@click:append="upDayFrom(fromDate)"
									prepend-icon="mdi-menu-left"
									@click:prepend="downDayFrom()"
									label="Start date"
									input-format-order="DD-MM-YYYY"
									dense
									class="rounded-lg"
									hide-details
									:disabled="loading"
								></bee-date-input>
							</v-col>

							<v-col
								v-if="speacifice === 'period'" 
								md="6"
								sm="12"
								:class="{
									'pt-0': $vuetify.breakpoint.mdAndUp
								}"
								class="px-0"
							>
								<bee-date-input
									v-model="toDate"
									append-icon="mdi-menu-right"
									@click:append="upDayTo()"
									prepend-icon="mdi-menu-left"
									@click:prepend="downDayTo()"
									label="End date"
									input-format-order="DD-MM-YYYY"
									dense
									class="rounded-lg"
									hide-details
									:disabled="loading"
								></bee-date-input>
							</v-col>
						</v-row>
					</v-col>
					<v-col v-if="$vuetify.breakpoint.md"></v-col>
					<v-col lg="1" sm="12" md="auto" align-self="center" class="py-0 d-flex flex-column justify-end">
						<v-btn 
							color="green-color white--text" 
							@click="search" 
							class="text-none rounded-lg px-5 my-2"
							width="100%"
							:disabled="loading || !projectIds.length"
						>
							Generate
						</v-btn>

						<v-btn 
							color="alert-color white--text" 
							@click="reset(); search" 
							class="text-none rounded-lg px-5"
							width="100%"
							:disabled="loading || (!userIds.length && !categoryId && !projectIds.length)"
						>
							Reset
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
		<v-data-table
			:headers="headers"
			:items="!projectIds.length || loading ? []: tasks"
			:loading="loading"
			show-expand
			single-expand
			:expanded.sync="expanded"
			item-key="user_id"
			class="elevation-1 rounded-lg mt-4"
			zebra
			dense
			:items-per-page="-1"
			hide-default-footer
		>
		<template v-slot:top>
			<div class="d-flex">
			<v-spacer></v-spacer>
			<p class="pr-4 pt-3 mb-0">
				<b>Total hours:</b> 
				<span v-if="!loading && projectIds.length">
					{{ tasks.length ? tasks.map(c => c.durationInMinute / 60).reduce((a, b) => a + b).toFixed(2) : 0 }} 
				</span>
				<span v-else> 0 </span>
				hours 
			</p>
			</div>
		</template>
		<template v-slot:item.userId="{ item }">
			{{ usersWithoutPag.find(c => c.id === item.userId)?.employee?.arabicFirstName + ' ' + usersWithoutPag.find(c => c.id === item.userId)?.employee?.arabicLastName }}
		</template>
		<template v-slot:item.durationInMinute="{ item }">
			{{ (item.durationInMinute / 60).toFixed(2) }} hours
		</template>
		<template v-slot:expanded-item="{ headers, item }">
			<td :colspan="headers.length">
			<v-simple-table>
				<template v-slot:default>
				<thead>
					<tr>
					<th>Task</th>
					<th>Date</th>
					<th>Duration</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="task in item.tasks" :key="task.id">
					<td dir="auto">{{ task.description }}</td>
					<td>
						{{
							moment(task.createdAt).format('YYYY-MM-DD')
						}}
					</td>

					<td>{{ (task.durationInMinute / 60).toFixed(2) }} hours</td>
					</tr>
				</tbody>
				</template>
			</v-simple-table>
			</td>
		</template>
		</v-data-table>
	</div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
	data: () => ({
		projectIds: [],
		categoryId: null,
		userIds: [],
		fromDate: null,
		toDate: null,
		leaves: null,
		divider: null,
		loading: false,
		menu1: false,
		menu2: false,

		tasks: [],
		totalHours: 0,
		dailyHours: 0,
		dailyHoursWithoutLeaves: 0,

		expanded: [],
		// 	[
		//   {
		//     "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		//     "durationInMinute": 0,
		//     "tasks": [
		//       {
		//         "id": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		//         "createdAt": "2025-03-12T13:25:05.156Z",
		//         "description": "string",
		//         "projectId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		//         "durationInMinute": 0,
		//         "workdayId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		//         "userId": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
		//       }
		//     ]
		//   }
		// ]
		headers: [
			{ text: 'Employee', value: 'userId', sortable: false },
			{ text: 'Hours', value: 'durationInMinute' },
			{ text: '', value: 'data-table-expand' }
		],
		speacifice: 'yearly',
		year: 2025,
		months: [
			'January ',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December'
		],
		month: null,
		projectLoading: false,
		hide: false
	}),

	methods: {
		moment,
		addYear () {
			this.year = this.years[this.years.indexOf(this.year) + 1]
		},
		subYear () {
			this.year = this.years[this.years.indexOf(this.year) - 1]
		},
		addMonth () {
			this.month = this.months[this.months.indexOf(this.month) + 1]
		},
		subMonth () {
			this.month = this.months[this.months.indexOf(this.month) - 1]
		},
		upDayFrom () {
			this.fromDate = moment(this.fromDate).add(1, 'day').format('YYYY-MM-DD')
			return this.fromDate
		},
	
		downDayFrom () {
			this.fromDate = moment(this.fromDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.fromDate
		},

		upDayTo () {
			this.toDate = moment(this.toDate).add(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},
	
		downDayTo () {
			this.toDate = moment(this.toDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},
		toggle () {
			this.$nextTick(() => {
				if (this.allProjects) {
					this.projectIds = []
				} else {
					this.projectIds = this.projectsBrief.slice()
				}
			})
		},
		search () {
			this.loading = true
			const monthNumber = this.months.indexOf(this.month) + 1
			this.$store.dispatch('statsctics/fetchProjectTasksWorkHours', { 
				fromDate: this.getFromDate,
				toDate: this.getToDate,
				projectIds: this.projectIds.length > 1 ? this.projectIds.map(c => c.id) : this.projectIds,
				userIds: this.userIds
			}).then((data) => {
				console.log(data)
				this.tasks = data
			}).finally(() => {
				this.loading = false
			})
		},

		CategoryChange () {
			this.projectIds = []
			// this.projectIds = this.projectsBrief.map((c) => c.id);
			if (this.categoryId) {
				this.projectLoading = true
				this.$store.dispatch('projects/fetchProjectById', {
					id: this.categoryId
				}).then((data) => {
					this.projectIds = data;
				}).finally(() => {
					this.projectLoading = false
				})
			}
		},

		reset () {
			this.userIds = []
			this.categoryId = null
			this.projectIds = []
			this.speacifice = 'yearly'
			this.tasks = []
		}
	},

	computed: {
		years () {
			const years = []
			for (let year = moment().year(); year > 2014; year--) {
				years.push(year)
			}
			return years
		},
		allProjects () {
			return this.projectIds.length === this.projectsBrief.length
		},
		someProjects () {
			return this.projectIds.length > 0 && !this.allProjects
		},
		icon () {
			if (this.allProjects) return 'mdi-close-box'
			if (this.someProjects) return 'mdi-minus-box'
			return 'mdi-checkbox-blank-outline'
		},
		...mapState({
			projectsBrief: state => state.projects.projectsBrief,
			categories: state => state.categories.categories,
			usersWithoutPag: state => state.users.usersWithoutPag
		}),
		...mapGetters({
			// getUserWithoutPagById: 'users/getUserWithoutPagById'
		}),

		getToDate () {
			const monthNumber = (this.months.indexOf(this.month) + 1).toString()
			let toDate = null
			if (this.speacifice === 'yearly') { 
				toDate = this.moment(this.moment((this.year).toString()).endOf('year')).format('YYYY-MM-DD') 
			} else {
				if (this.speacifice === 'monthly') {
					toDate = this.year + '-' + (
						monthNumber >= 10 
							? monthNumber 
							: '0' + monthNumber
					) + '-' + this.moment(this.moment(monthNumber).endOf('month')).format('DD')
				} else {
					toDate = this.toDate
				}
			}
			return toDate
		},

		getFromDate () {
			const monthNumber = this.months.indexOf(this.month) + 1
			let fromDate = null
			if (this.speacifice === 'yearly') {
				fromDate = this.moment(this.moment((this.year).toString())).format('YYYY-MM-DD') 
			} else {
				if (this.speacifice === 'monthly') {
					fromDate = this.year + '-' + (
						monthNumber >= 10 ? monthNumber : '0' + monthNumber
					) + '-' + '01'
				} else {
					fromDate = this.fromDate
				}
			}
			return fromDate
		}
	},

	created () {
		this.loading = true
		Promise.all([
			!this.categories.length ? this.$store.dispatch('categories/fetchAll') : null,
			!this.usersWithoutPag.length ? this.$store.dispatch('users/fetchUsersWithoutPag', { isActiveOnly: true }) : null,
			!this.projectsBrief.length ? this.$store.dispatch('projects/fetchProjectBrief').then((data) => { console.log(data) }) : null
		]).finally(() => {
			this.loading = false
		})
	}
}
</script>
